import type { ViewComponentInstance } from '../../types/view-config.types';

/** A topic is a detail route; its article gallery is still a collection. */
export function requiresCollectionScope(componentType: string): boolean {
  return componentType === 'knowledge-base-gallery';
}

/** Correct legacy derived row bindings in memory, never rewrite app data. */
export function normalizeComponentCollectionBinding(
  instance: ViewComponentInstance
): ViewComponentInstance {
  if (
    !requiresCollectionScope(instance.componentType) ||
    instance.dataBinding?.contextScope !== 'row'
  )
    return instance;
  return {
    ...instance,
    dataBinding: { ...instance.dataBinding, contextScope: 'source' },
  };
}
